import React, { PureComponent, Fragment } from 'react'
import {
  TableCell,
  TableHead,
  Table,
  TableRow,
  TableBody,
  Paper,
  Grid,
  Button,
  ListItem,
  Typography,
  Tab,
  Tabs,
} from '@material-ui/core'
import { connect } from 'react-redux'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import DeliveryTaxItemContainer from '../../../components/DeliveryTax/DeliveryTaxItemContainer'
import { getCompanyFeatures, getRegions } from '../../../actions/company'
import {
  getDeliveryTaxRate,
  updateDeliveryTaxRate,
  postDeliveryTaxRate,
  deleteDeliveryTaxRate,
  getTaxesDisplayNames,
  updateTaxesDisplayNames,
  saveUpdatedShop,
} from '../../../actions/shop'
import { getConsumerTypes } from '../../../api/consumer-type'
import { hasAccess, getSession } from '../../../utils/api'
import { convertArrayToOptions } from '../../../utils/array'
import {
  emptyDeliveryTaxOption,
  scrollElementIntoView,
  emptyNonCannabisDeliveryTaxOption,
} from '../../../utils/common'
import TaxOption from '../../../components/TaxOption/TaxOption'
import {
  EditableTextField,
  EditableSwitch,
  EditableReactSelect,
} from '../../../components/common/EditableComponents'
import EditActionComponent from '../../../components/common/EditActionComponent'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import ModalDialog from '../../../components/common/ModalDialog'
import { isValidString } from '../../../utils/string'
import { Appcues } from '../../../utils/constants'

class DeliveryTax extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedTaxToEdit: null,
      selectedTaxToDelete: null,
      editMode: false,
      lastModifiedState: null,
      taxDisplayNames: [],
      activeTab: 'Cannabis',
      consumerTypes: [],
    }
  }

  componentDidMount() {
    this.props.dispatch(getRegions())
    this.getDeliveryTaxRates()
    this.getTaxesDisplayNames()
    this.props.dispatch(getCompanyFeatures())
    this.fetchConsumerTypes()
  }

  fetchConsumerTypes = async () => {

    const consumerTypes = await getConsumerTypes() 
    if (consumerTypes) {
      this.setState({ consumerTypes })
    }
  }


  getDeliveryTaxRates = () => {
    const { shop = {} } = this.props
    this.props.dispatch(getDeliveryTaxRate(shop.id))
  }

  updateTaxDisplayNames = (updatedTaxDisplayNames, afterSave) => {
    this.props.dispatch(updateTaxesDisplayNames(updatedTaxDisplayNames)).then((res) => {
      afterSave(res)
      const session = getSession()
      this.props.dispatch(
        saveUpdatedShop({ shop: res, session: { ...session, assignedShop: res } }),
      )
      this.props.dispatch(openSuccessMessage('Tax Display Names updated successfully'))
      this.getTaxesDisplayNames()
    })
  }

  getTaxesDisplayNames = () => {
    this.props.dispatch(getTaxesDisplayNames()).then((res) => {
      this.setState({ taxDisplayNames: res, lastModifiedDisplayNames: new Date().getTime() })
    })
  }

  addTaxRate = () => {
    Appcues.track('Adding Tax Rate')
    const { editMode = false } = this.state

    if (editMode) {
      return this.props.dispatch(openErrorMessage('Please save current Tax Options'))
    }

    this.setState(
      {
        selectedTaxToEdit: { ...emptyDeliveryTaxOption },
        editMode: true,
      },
      () => {
        scrollElementIntoView('selected-tax')
      },
    )
  }

  onEdit = (index) => () => {
    const { deliveryTaxRates = [] } = this.props.shopReducer
    let selectedTaxToEdit = deliveryTaxRates[index]

    if (!selectedTaxToEdit.nonCannabisTaxInfo) {
      selectedTaxToEdit = { ...selectedTaxToEdit, ...emptyNonCannabisDeliveryTaxOption }
    }

    this.setState(
      {
        selectedTaxToEdit: { ...(selectedTaxToEdit || {}) },
        editMode: false,
        lastModifiedState: new Date().valueOf(),
      },
      () => {
        setTimeout(() => {
          scrollElementIntoView('selected-tax')
        }, 100)
      },
    )
  }

  onCancelEdit = () => {
    const { deliveryTaxRates = [] } = this.props.shopReducer
    const { selectedTaxToEdit = {} } = this.state

    if (selectedTaxToEdit && selectedTaxToEdit.id) {
      const taxIndex = deliveryTaxRates.findIndex((taxRate) => taxRate.id === selectedTaxToEdit.id)
      if (taxIndex !== -1) {
        let selectedTaxToEdit = deliveryTaxRates[taxIndex]
        if (!selectedTaxToEdit.nonCannabisTaxInfo) {
          selectedTaxToEdit = { ...selectedTaxToEdit, ...emptyNonCannabisDeliveryTaxOption }
        }
        this.setState({
          selectedTaxToEdit: { ...(selectedTaxToEdit || {}) },
          lastModifiedState: new Date().valueOf(),
        })
      }
    } else {
      this.setState({
        selectedTaxToEdit: null,
      })
    }
    this.toggleEdit()
  }

  onSaveTaxOptions = (data, callback) => {
    return
    /* this.setState({
            selectedTaxToEdit: {
                ...data
            },
            lastModifiedState: new Date().valueOf()

        });
        callback && callback(); */
  }

  onChange = (key, isCheckBox) => (event) => {
    const value = isCheckBox ? event.target.checked : event.target.value
    const { selectedTaxToEdit } = this.state
    this.setState({
      selectedTaxToEdit: {
        ...selectedTaxToEdit,
        [key]: value,
      },
    })
  }

  onChangeSelectOptions = (key) => (values) => {
    const { selectedTaxToEdit = {} } = this.state
    const updatedValues = values && values.map((item) => item.value)

    this.setState({
      selectedTaxToEdit: {
        ...selectedTaxToEdit,
        [key]: updatedValues,
      },
    })
  }

  newOnchange = (key) => (values) => {
    const { selectedTaxToEdit = {} } = this.state
    const newValue = [values[values.length > 0 ? values.length - 1 : 0]]
    const updatedValues = newValue && newValue.map((item) => (item && item.value) || '')
    this.setState({
      selectedTaxToEdit: {
        ...selectedTaxToEdit,
        [key]: updatedValues,
      },
    })
  }

  getKeyForNonCannabis = (key) => {
    let nonCannabisKey = ''
    switch (key) {
      case 'useComplexTax':
        nonCannabisKey = 'nonCannabisUseComplexTax'
        break
      case 'taxOrder':
        nonCannabisKey = 'nonCannabisTaxOrder'
        break
      case 'taxInfo':
        nonCannabisKey = 'nonCannabisTaxInfo'
        break
      case 'taxTables':
        nonCannabisKey = 'nonCannabisTaxTables'
        break
    }
    return nonCannabisKey
  }

  updateTaxOption = (key, value, afterSave) => {
    this.setState((prevState) => ({
      selectedTaxToEdit: {
        ...prevState.selectedTaxToEdit,
        [key]: value,
      },
    }))
    afterSave && afterSave()
  }

  onChangeTaxOptions = (key, value, afterSave) => {
    const { activeTab } = this.state
    let optionKey = key
    if (activeTab == 'NonCannabis') {
      optionKey = this.getKeyForNonCannabis(key)
    }

    this.updateTaxOption(optionKey, value, afterSave)
  }

  onSave = () => {
    Appcues.track('Tax details saved')
    const { selectedTaxToEdit = {} } = this.state

    const { name = '', regionIds = [] } = selectedTaxToEdit || {}

    if (!isValidString(name)) {
      return this.props.dispatch(openErrorMessage('Please enter name for delivery tax rate'))
    }
    // if (!(regionIds && regionIds.length)) {
    //     return this.props.dispatch(openErrorMessage('Please select a region'));
    // }

    if (selectedTaxToEdit.id) {
      this.props.dispatch(updateDeliveryTaxRate(selectedTaxToEdit)).then((res) => {
        this.props.dispatch(openSuccessMessage('Delivery Tax rate updated successfully'))
        this.getDeliveryTaxRates()
        this.setState({
          selectedTaxToEdit: null,
        })
        this.toggleEdit()
      })
    } else {
      this.props.dispatch(postDeliveryTaxRate(selectedTaxToEdit)).then((res) => {
        this.props.dispatch(openSuccessMessage('Delivery Tax rate saved successfully'))
        this.getDeliveryTaxRates()
        this.setState({
          selectedTaxToEdit: null,
        })
        this.toggleEdit()
      })
    }
  }

  disableEdit = (disableEditCallback) => {
    disableEditCallback && disableEditCallback()
  }

  onDelete = (index) => () => {
    const { deliveryTaxRates = [] } = this.props.shopReducer
    this.setState({
      selectedTaxToDelete: { ...(deliveryTaxRates[index] || {}) },
    })
    this.confirmModal.handleClickOpen()
  }

  resetTaxToDelete = () => {
    setTimeout(
      () =>
        this.setState({
          selectedTaxToDelete: null,
        }),
      100,
    )
  }

  onConfirmDelete = () => {
    const { selectedTaxToDelete = {} } = this.state
    this.props.dispatch(deleteDeliveryTaxRate(selectedTaxToDelete.id)).then((res) => {
      this.props.dispatch(openSuccessMessage('Delivery tax rate deleted successfully'))
      this.setState({
        selectedTaxToDelete: null,
      })
      this.getDeliveryTaxRates()
      this.confirmModal.handleClose()
    })
  }

  toggleEdit = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
    }))
  }

  filteredUsedRegions = (regionsValues, deliveryTaxRates) => {
    let allRegionIds = []

    //getting all regionIds of all deliveryRates
    for (let deliveryTaxRate of deliveryTaxRates) {
      if (deliveryTaxRate.regionIds && deliveryTaxRate.regionIds.length > 0)
        allRegionIds = [...allRegionIds, ...deliveryTaxRate.regionIds]
    }

    let duplicatedRegions = []
    //get repetead region objects
    for (let regionId of allRegionIds) {
      let duplicate = regionsValues.find((region) => region.id === regionId)
      if (duplicate) {
        duplicatedRegions = [...duplicatedRegions, duplicate]
      }
    }

    //filter objects
    let filteredRegions = regionsValues.filter((region) => !duplicatedRegions.includes(region))

    return filteredRegions
  }

  changeActiveTab = (e, value) => {
    this.setState({
      activeTab: value,
    })
  }

  render() {
    const { regions = {}, companyFeatures = {} } = this.props.companyReducer
    const { lastModified = null, deliveryTaxRates = [] } = this.props.shopReducer
    const { nalExciseAfterCityTax = false } = this.props.shop
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}
    const {
      selectedTaxToEdit = null,
      selectedTaxToDelete = null,
      editMode = false,
      lastModifiedState,
      taxDisplayNames = [],
      activeTab = 'Cannabis',
      consumerTypes,
    } = this.state

    const regionsValues =
      (regions && regions.values && regions.values.filter((region) => region.active)) || []

    const selectedRegions = selectedTaxToEdit
      ? regionsValues.filter((region) => {
          return selectedTaxToEdit.regionIds.find(
            (regionId) => region.active && region.id === regionId,
          )
        }) || []
      : []

    const session = getSession()
    const { assignedShop = {} } = session || {}
    const { availableApps = [] } = companyFeatures
    let filteredUsedRegions = this.filteredUsedRegions(regionsValues, deliveryTaxRates)

    let nonCannabisData = {}
    if (selectedTaxToEdit) {
      nonCannabisData = {
        ...selectedTaxToEdit,
        useComplexTax: selectedTaxToEdit.nonCannabisUseComplexTax,
        taxOrder: selectedTaxToEdit.nonCannabisTaxOrder,
        taxInfo: selectedTaxToEdit.nonCannabisTaxInfo,
        taxTables: selectedTaxToEdit.nonCannabisTaxTables,
      }
    }

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {hasAccess() ? (
            <div className="pull-right margin-bottom-small">
              <Button className="primary-button margin" onClick={this.addTaxRate}>
                Add Tax Rate
              </Button>
            </div>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="table-scroll-mobile">
            <Paper className="paper-page" elevation={2}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Regions</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deliveryTaxRates.map((elem, i) => {
                    return (
                      <DeliveryTaxItemContainer
                        key={i}
                        data={elem}
                        regions={(regions && regions.values) || []}
                        lastModified={lastModified}
                        onEdit={this.onEdit(i)}
                        onDelete={this.onDelete(i)}
                      />
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
            {selectedTaxToEdit ? (
              <Fragment>
                <Grid container id="selected-tax">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div className="pull-right margin-bottom-small">
                      <EditActionComponent
                        onSave={this.onSave}
                        onCancel={this.onCancelEdit}
                        editMode={editMode}
                        onEdit={this.toggleEdit}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Paper className="paper-page" elevation={6}>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Name
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableTextField
                          valueToRender={selectedTaxToEdit.name}
                          editMode={editMode}
                          value={selectedTaxToEdit.name}
                          onChange={this.onChange('name')}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Regions
                      </Grid>

                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        {' '}
                        {/*ToDo : Select editable can be improved */}
                        {availableApps.length > 0 &&
                        availableApps &&
                        availableApps.indexOf('Dispatch') >= 0 ? (
                          <EditableReactSelect
                            className="terminal-select"
                            multi={true}
                            value={convertArrayToOptions(selectedRegions)}
                            onChange={this.onChangeSelectOptions('regionIds')}
                            valueToRender={selectedRegions.map((region) => region.name).join(', ')}
                            editMode={editMode}
                            options={convertArrayToOptions(filteredUsedRegions)}
                            clearable={false}
                          />
                        ) : (
                          <EditableReactSelect
                            className="terminal-select"
                            multi={true}
                            value={convertArrayToOptions(selectedRegions)}
                            onChange={this.onChangeSelectOptions('regionIds')}
                            valueToRender={selectedRegions.map((region) => region.name).join(', ')}
                            editMode={editMode}
                            options={convertArrayToOptions(regionsValues)}
                            clearable={false}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Status
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={selectedTaxToEdit.active ? 'Enabled' : 'Disabled'}
                          checked={selectedTaxToEdit.active}
                          editMode={editMode}
                          onChange={this.onChange('active', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <div className="delivery-tax-options">
                    <Tabs
                      value={this.state.activeTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={this.changeActiveTab}
                      centered
                      className="margin-bottom-small"
                    >
                      <Tab label="Cannabis Tax" value="Cannabis" />
                      <Tab label="Non-cannabis Tax" value="NonCannabis" />
                    </Tabs>
                    {activeTab === 'Cannabis' ? (
                      <TaxOption
                        editMode={editMode}
                        data={{
                          ...selectedTaxToEdit,
                          enableExciseTax: assignedShop.enableExciseTax,
                        }}
                        onSave={this.disableEdit}
                        lastModified={lastModifiedState}
                        hideEditAction={true}
                        onChange={this.onChangeTaxOptions}
                        showEdit={editMode}
                        taxDisplayNames={taxDisplayNames}
                        updateTaxDisplayNames={this.updateTaxDisplayNames}
                        isNalTaxesOnly={flagisNalTaxesOnly}
                        isNalExciseAfterCityTax={nalExciseAfterCityTax}
                        consumerTypes={consumerTypes}
                      />
                    ) : null}
                    {activeTab === 'NonCannabis' ? (
                      <TaxOption
                        editMode={editMode}
                        data={{ ...nonCannabisData, enableExciseTax: assignedShop.enableExciseTax }}
                        onSave={this.disableEdit}
                        lastModified={lastModifiedState}
                        hideEditAction={true}
                        onChange={this.onChangeTaxOptions}
                        showEdit={editMode}
                        taxDisplayNames={taxDisplayNames}
                        updateTaxDisplayNames={this.updateTaxDisplayNames}
                        isNonCannabis
                        consumerTypes={consumerTypes}
                      />
                    ) : null}
                  </div>
                </Paper>
              </Fragment>
            ) : null}
          </div>
          <ModalDialog
            title={`Delete ${(selectedTaxToDelete && selectedTaxToDelete.name) || ''}`}
            ref={(c) => (this.confirmModal = c)}
            onConfirm={this.onConfirmDelete}
            confirmText={'Delete'}
            onClose={this.resetTaxToDelete}
          >
            <Typography variant="subheading" gutterBottom>
              Are you sure you want to delete the selected delivery tax rate '
              {(selectedTaxToDelete && selectedTaxToDelete.name) || ''}'?
            </Typography>
          </ModalDialog>
        </Grid>
      </Grid>
    )
  }
}

export default connect(({ shopReducer, companyReducer, authReducer, dispatch }) => ({
  shopReducer,
  companyReducer,
  authReducer,
  dispatch,
}))(ShopSettingsWithUpdate(ContainerWithTitleWrapper(DeliveryTax, 'Delivery Tax Rates')))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/DeliveryTax.js